import {Button, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import axios from "axios";
import {toast} from "react-toastify";
import {setSelectedPrimerPos} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import Dropdown from "../../../../primer/Dropdown";
import Input from "../../../../common/Input";


const UnlockPosModal = ({show, setShow}) => {
    const dispatch = useDispatch();
    const selectedPos = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPos);
    const [unlockLoader, setUnlockLoader] = useState(false);
    const [byPassHours, setByPassHours] = useState("24");

    useEffect(() => {
        if(show) setByPassHours("24");
    }, [show]);

    const hoursOptions = [
        {label: "24 Ώρες", value: "24"},
        {label: "48 Ώρες", value: "48"},
        {label: "72 Ώρες", value: "72"},
        {label: "96 Ώρες", value: "96"},
    ]

    const unlockDevice = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            setUnlockLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-unlock", {_id: selectedPos?._id, byPassHours: byPassHours}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setUnlockLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        if(res.data?.data) dispatch(setSelectedPrimerPos(res.data.data));
                        setShow(false);
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setUnlockLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    return (
        <Modal backdrop={"static"} className="themeModal" show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Ξεκλείδωμα Συσκευής</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span style={{fontSize: "13px"}} className={"text-muted"}><i>
                    Η συσκευή έχει κλειδώσει λόγω αποτυχίας πληρωμής της συνδρομής. Η συσκευή ξεκλειδώνει αυτόματα με την εξόφληση της συνδρομής.
                    Εάν θέλετε να ξεκλειδώσετε την συσκευή για περιορισμένο χρονικό διάστημα παρακαλώ επιλέξτε για πόσες ώρες θέλετε να παραμείνει το τερματικό ξεκλείδωτο.
                    Με το ξεκλείδωμα της συσκευής θα αποσταλεί email στον πελάτη με τον κωδικό.
                    ΠΡΟΣΟΧΗ! Εάν λήξει ο παρακάτω χρόνος και η συνδρομή παραμένει ανεξόφλητη η συσκευή θα ξανακλειδώσει αυτόματα!
                    </i></span>
                <hr />
                <Input
                    label={"Κωδικός Ξεκλειδώματος"}
                    name={"lockPassword"}
                    disabled={true}
                    type={"text"}
                    value={selectedPos?.lockPassword}
                />
                <Dropdown
                    className="mt-1"
                    name={"bypassHours"}
                    label={"Ώρες περιόδου χάριτος"}
                    disabled={unlockLoader}
                    required={true}
                    key={Math.random()}
                    defaultValue={hoursOptions.find((el) => el.value === byPassHours)}
                    options={hoursOptions}
                    onChange={(e) => setByPassHours(e.value)}
                />

            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)}>
                    Κλείσιμο
                </Button>
                <Button
                    variant="primary"
                    disabled={unlockLoader}
                    onClick={() => unlockDevice()}>
                    {"Ξεκλείδωμα συσκευής "}
                    {unlockLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default UnlockPosModal;